<script>
import SrvUsers from '@/services/srv-users'
import SrvGeneral from '@/services/srv-general'
import HTTP_ONPREMISE from '@/config/axios-config-login-onpremise'

export default {
  data() {
    return {
      dMostrarAvisoCambioEmpresa: false,
      dEmpresaERP: null,
      dEmpresaInformes: null,
      dTextAvisoCambioEmpresa: this.$t('cambioEmpresaTexto1') + this.dEmpresaERP + this.$t('cambioEmpresaTexto2') + this.dEmpresaInformes + this.$t('cambioEmpresaTexto3'),
      textAviso: '',
      usuario: '',
      tira: '',
      dEsperandoLogin: false,
      mostrarAvisos: true,
      dTienda: false,
      dDatosAutenticacion: 'datos-autenticacion',
      idiomaUsuario: "fr",
      tokenRefresh: 'x-ddol-refresh-token'
    }
  },
  methods: {
    iniciaSesion() {
      // Limpia la cache
      // 
      this.dEsperandoLogin = true
      if (this.$refs.form.validate()) {
        if (localStorage.getItem('isOnPremise') === 'yes') {
          this.inicioSesionOnPremise(false)
        } else {
          this.inicioSesionDDOL(false)
        }
      } else {
        this.dEsperandoLogin = false
      }
    },
    fSetRefreshToken(refreshToken) {
      if (refreshToken) {
        this.$store.commit('setRefreshToken', refreshToken)
      }
    },
    inicioSesionDDOL(external) {
      // Limpia la cache
      const headers = {
        'x-ddol-user': this.usuario,
        'x-ddol-org': this.dominio,
        'x-ddol-apporg': 'EPOR'
      }

      const informacionLogin = {
        userName: this.usuario,
        password: this.password,
        domain: this.dominio,
        refreshToken: { expirationSeconds: 864000 }
      }
      if (!external) {
        // llama al web service de validacion (obtiene token)
        SrvUsers.validateuser(informacionLogin, headers).then(response => {
          this.tira = response.data
          this.fSetRefreshToken(response.headers[this.tokenRefresh])
          const headersDomain = {
            'x-ddol-user': this.usuario,
            'x-ddol-org': this.dominio,
            'x-ddol-apporg': 'EPOR',
            'x-ddol-security-token': this.tira
          }
          const payload = {
            'dominio': this.dominio,
            'url': document.location.hostname
          }
          const promise = []
          promise.push(
            SrvGeneral.getData(payload, headersDomain).then(response => {
              return response
            }).catch(error => {
              return error
            })
          )

          Promise.all(promise).then(result => {
            if (result.length > 0) {
              this.$store.commit('setUrlInfo', result[0].data)

              if (this.token !== null) {
                this.inicioSesionUsuario(external)
              }
            } else {
              this.$store.commit('removeAutenticacion');
              this.$router.push('/');
            }
          })
        }).catch(error => {
          console.log(error)
          this.dEsperandoLogin = false
          this.textAviso = '<b>' + this.$t('notLoginDefault') + '</b><br> ' + this.$t('errorLoginText')
          this.mostrarAvisos = true
          this.dEsperandoLogin = false
          localStorage.removeItem(this.dDatosAutenticacion)
        })
      } else {
        const headersDomain = {
          'x-ddol-org': this.dominio,
          'x-ddol-apporg': 'EPOR',
          'x-ddol-security-token': this.tira
        }
        const payload = {
          'dominio': this.dominio,
          'url': document.location.hostname
        }

        const promise = []
        promise.push(
          SrvGeneral.getData(payload, headersDomain).then(response => {
            this.fSetRefreshToken(response.headers[this.tokenRefresh])
            return response
          }).catch(error => {
            return error
          })
        )

        Promise.all(promise).then(result => {

          if (result.length > 0) {
            this.$store.commit('setUrlInfo', result[0].data)
            if (this.token !== null) {
              this.inicioSesionUsuario(external)
            }
          } else {
            this.$store.commit('removeAutenticacion')
            this.$router.push('/')
          }
        })
      }
    },
    fCambioTextoDialog() {
      this.dTextAvisoCambioEmpresa = this.$t('cambioEmpresaTexto1') + this.dEmpresaERP + this.$t('cambioEmpresaTexto2') + this.dEmpresaInformes + this.$t('cambioEmpresaTexto3')
    },
    inicioSesionUsuario(external) {
      let tiraAux
      if (external) {
        tiraAux = this.tira
      } else {
        tiraAux = localStorage.getItem(this.dDatosAutenticacion) != null
          ? JSON.parse(localStorage.getItem(this.dDatosAutenticacion)).tira
          : this.tira
      }

      const informacionLogin = {
        tira: tiraAux
      }
      const datosLoginTemp = { tira: tiraAux }
      localStorage.setItem(this.dDatosAutenticacion, JSON.stringify(datosLoginTemp))

      this.fComprobarEmpresa(external).then(result => {
        if (result) {
          this.fCambioTextoDialog()
          this.dMostrarAvisoCambioEmpresa = true
        } else {
          // llama al web service de validacion (obtiene token)
          SrvUsers.datosUsuarioPortal(informacionLogin).then(response => {
            const datosUsuario = response.data
            if (datosUsuario.statusCode !== '200') {
              this.textAviso = datosUsuario.errorMsg
              this.dEsperandoLogin = false
              this.mostrarAvisos = true
            } else if (datosUsuario.result.length > 0) {
              // Establecemos el token para las siguientes llamadas con axios.
              if ((datosUsuario.result[0].role === undefined) || (datosUsuario.result[0].role === '')) {
                this.textAviso = this.$t('noConfigurado')
                this.dEsperandoLogin = false
                this.mostrarAvisos = true
              } else { // Inicio de sesión completado con éxito
                const datosLogin = {}
                datosLogin.tira = tiraAux
                datosLogin.organizacion = datosUsuario.result[0].organizacion
                datosLogin.usuario = datosUsuario.result[0].login

                datosLogin.nombreUsuario = datosUsuario.result[0].nombre
                datosLogin.empresa = datosUsuario.result[0].empresa
                datosLogin.nombreEmpresa = datosUsuario.result[0].nombreEmpresa
                datosLogin.proveedor = datosUsuario.result[0].proveedor;
                datosLogin.sucursalProv = datosUsuario.result[0].sucursalProv;
                datosLogin.role = datosUsuario.result[0].role
                datosLogin.cliente = datosUsuario.result[0].cliente
                datosLogin.clienteNombre = datosUsuario.result[0].clienteNombre
                datosLogin.sucursal = datosUsuario.result[0].sucursal
                datosLogin.sucursalNombre = datosUsuario.result[0].sucursalNombre
                datosLogin.representante = datosUsuario.result[0].representante
                datosLogin.agente = datosUsuario.result[0].agente
                datosLogin.representanteNombre = datosUsuario.result[0].representanteNombre
                datosLogin.nivelMaxArt = datosUsuario.result[0].nivelMaxArt;
                datosLogin.usuarioExpertSN = datosUsuario.result[0].usuarioExpertSN;
                datosLogin.email = datosUsuario.result[0].email;

                this.$store.commit('setAutenticacion', datosLogin)
                localStorage.setItem(this.dDatosAutenticacion, JSON.stringify(datosLogin))
                // Entra en la aplicacion
                // this.$router.push('/app')
                this.generateStatus()
                this.dEsperandoLogin = false
                this.$bus.$emit('evento-cargaPaginaApp')
              }
            } else {
              this.dEsperandoLogin = false
              this.textAviso = this.$t('noConfigurado')
              this.mostrarAvisos = true
              this.$store.commit('removeAutenticacion')
              this.$router.push('/')
            }
          }).catch(error => {
            console.log(error)
            this.textAviso = '<b>' + this.$t('notLoginDefault') + '</b><br> ' + this.$t('errorComprobarEmpresa')
            this.mostrarAvisos = true
            this.dEsperandoLogin = false
            localStorage.removeItem(this.dDatosAutenticacion)
          })
        }
      })
    },

    // Comprueba si la empresa en la que se encuentra el usuario coincide en el ERP
    fComprobarEmpresa(external) {
      let tiraAux = ''
      if (external) {
        tiraAux = this.tira
      } else {
        tiraAux = localStorage.getItem(this.dDatosAutenticacion) != null ? JSON.parse(localStorage.getItem(this.dDatosAutenticacion)).tira : this.tira
      }
      const payload = {
        tira: tiraAux,
        getAvatarSN: 'N'
      }
      // Obtener la empresa del ERP
      return Promise.all([
        SrvUsers.datosUsuario(payload).then(response => {
          return response.data
        })
      ]).then(respuesta => {
        if (respuesta.errorMsg !== undefined) {
          return false
        }
        if (respuesta[0].usuario) {
          const datosLogin = {
            usuario: respuesta[0].usuario,
            tira: localStorage.getItem(this.dDatosAutenticacion) != null ? JSON.parse(localStorage.getItem(this.dDatosAutenticacion)).tira : this.tira,
            empresa: respuesta[0].empresa != null ? respuesta[0].empresa : '',
            userId: respuesta[0].userId,
            orgId: respuesta[0].orgId,
            idiomaUsuario: respuesta[0].idiomaUsuario
          }

          if (datosLogin.idiomaUsuario === 'E') {
            datosLogin.idiomaUsuario = 'es' //Solo porque no está configurado el multiidioma en el erp
          }
          this.$i18n.locale = datosLogin.idiomaUsuario //cambia el idioma del portal al que tenga asignado el usuario en MENUGEN_USUARIO

          this.$store.commit('setAutenticacionPortal', datosLogin)
          localStorage.setItem(this.dDatosAutenticacion, JSON.stringify(datosLogin))
        }
        if (respuesta[0].errorCode && respuesta[0].errorCode === 2002) {
          return false
        }
        this.dEmpresaERP = respuesta[0].empresa
        if (this.$store.getters.getUrlInfo) {
          this.dEmpresaInformes = this.$store.getters.getUrlInfo.empresa
        }
        if (external) {
          this.dEmpresaInformes = this.dEmpresaERP
          if (this.$store.getters.getUrlInfo) {
            this.$store.getters.getUrlInfo.empresa = this.dEmpresaERP
          }
        }
        if (this.dEmpresaInformes === undefined || this.dEmpresaInformes === this.dEmpresaERP || this.dEmpresaInformes === 'undefined' || this.dEmpresaInformes === null || this.dEmpresaERP === null) {
          return false
        } else {
          this.dTextAvisoCambioEmpresa = this.$t('cambioEmpresaTexto1') + this.dEmpresaERP + this.$t('cambioEmpresaTexto2') + this.dEmpresaInformes + this.$t('cambioEmpresaTexto3')
          return true
        }
      }).catch(error => {
        console.log("ERROR:", error);
      })
    },
    async fObtenerDatosUsuario() {
      try {
        const tiraAux = localStorage.getItem(this.dDatosAutenticacion)
          ? JSON.parse(localStorage.getItem(this.dDatosAutenticacion)).tira
          : this.tira;

        const payload = {
          tira: tiraAux,
          getAvatarSN: 'N',
        };

        // Realiza la llamada al WS
        const response = await SrvUsers.datosUsuario(payload);

        if (response.data.errorMsg) {
          console.error("Error en la respuesta:", response.data.errorMsg);
          return null;
        }

        const respuesta = response.data;
        const datosLogin = {};

        if (respuesta.usuario) {
          datosLogin.usuario = respuesta.usuario;
          datosLogin.tira = tiraAux;
          datosLogin.empresa = respuesta.empresa || '';
          datosLogin.userId = respuesta.userId;
          datosLogin.orgId = respuesta.orgId;
          datosLogin.idiomaUsuario = respuesta.idiomaUsuario === 'E' ? 'es' : respuesta.idiomaUsuario;

          // Actualiza el estado y localStorage
          this.$store.commit('setAutenticacionPortal', datosLogin);
        }

        return datosLogin; // Devuelve el objeto datosLogin
      } catch (error) {
        console.error("Error:", error);
        return null; // Devuelve null si hay un error
      }
    },
    fCambiarEmpresa() {
      const payload = {
        usuario: JSON.parse(localStorage.getItem(this.dDatosAutenticacion)).usuario.toUpperCase(),
        empresa: this.$store.getters.getUrlInfo.empresa,
        tira: JSON.parse(localStorage.getItem(this.dDatosAutenticacion)).tira
      }

      SrvUsers.setEmpresa(payload).then(response => {
        if (response.data.result !== 'ko') {
          this.dMostrarAvisoCambioEmpresa = false
          this.inicioSesionUsuario(false)
          return response.data
        } else {
          this.dMostrarAvisoCambioEmpresa = false
          this.$store.commit('removeAutenticacion')
          this.$router.push('/')
          return null
        }
      })
    },
    /*
     * inicia sesion on premise
     */
    inicioSesionOnPremise(external) {
      localStorage.setItem('ddolSecurityKey', process.env.KEYSPREMISE[localStorage.getItem('headerDomain')])

      const handleGenericLoginError = () => {
        this.textAviso = '<b>' + this.$t('notLoginDefault') + '</b><br> ' + this.$t('notLoginDefaultDesc')
        this.dEsperandoLogin = false
        this.mostrarAvisos = true
        this.$store.commit('removeAutenticacion')
      }

      const setDatosAutenticacionFromUsuario = (datosUsuario, datosAutenticacion, datosLogin, includeExtraLoginFields) => {
        const user = datosUsuario.result[0]
        datosAutenticacion.organizacion = user.organizacion
        datosAutenticacion.usuario = user.login
        datosAutenticacion.nombreUsuario = user.nombre
        datosAutenticacion.empresa = user.empresa
        datosAutenticacion.nombreEmpresa = user.nombreEmpresa
        datosAutenticacion.role = user.role
        datosAutenticacion.cliente = user.cliente
        datosAutenticacion.representante = user.representante
        datosAutenticacion.representanteNombre = user.representanteNombre
        datosAutenticacion.agente = user.agente
        datosLogin.nivelMaxArt = user.nivelMaxArt
        if (includeExtraLoginFields) {
          datosLogin.usuarioExpertSN = user.usuarioExpertSN
          datosLogin.permiteCreaOCSN = user.permiteCreaOCSN
        }
      }

      if (!external) {
        const informacionLogin = {
          usuario: this.usuario,
          password: this.password,
          dominio: this.dominio
        }
        //
        const self = this.$i18n;
        // 
        HTTP_ONPREMISE.post('/wscomun/procExpert/login', informacionLogin).then((response) => {
          if (!response.data.errorCode || response.data.errorCode === '') {
            this.fSetRefreshToken(response.headers[this.tokenRefresh])
            const tiraAux = response.data.tira
            const datosLogin = response.data
            const headersDomain = {
              'x-ddol-user': this.usuario,
              'x-ddol-org': this.dominio,
              'x-ddol-apporg': 'EPOR',
              'x-ddol-security-token': response.data.tira
            }
            const payload = {
              dominio: this.dominio,
              url: document.location.hostname,
              usrAplMemcache: this.usuario
            }

            Promise.all([
              SrvGeneral.getData(payload, headersDomain).then(r => r).catch(e => e)
            ]).then(result => {
              if (result.length <= 0) {
                this.$store.commit('removeAutenticacion')
                this.$router.push('/')
              }
              this.$store.commit('setUrlInfo', result[0].data)
              if (datosLogin.errorCode) {
                this.textAviso = datosLogin.errorMsg
                this.mostrarAvisos = true
                this.dEsperandoLogin = false
              } else {
                this.token = response.data.tira
                this.tira = response.data.tira
                const datosAutenticacion = {
                  tira: this.token
                }
                this.$store.commit('setAutenticacion', datosAutenticacion)
                localStorage.setItem(this.dDatosAutenticacion, JSON.stringify(datosAutenticacion))
                this.dEmpresaERP = response.data.empresa
                this.dEmpresaInformes = this.dEmpresaERP
                if (this.$store.getters.getUrlInfo) {
                  this.$store.getters.getUrlInfo.empresa = this.dEmpresaERP
                }
                // 
                const informacionLogin = { tira: tiraAux }

                Promise.all([
                  SrvUsers.datosUsuarioPortal(informacionLogin).then(response => {
                    const datosUsuario = response.data
                    if (datosUsuario.statusCode !== '200' && datosUsuario.result.length > 1) {
                      this.textAviso = datosUsuario.errorMsg
                      this.dEsperandoLogin = false
                      this.mostrarAvisos = true
                    } else {
                      setDatosAutenticacionFromUsuario(datosUsuario, datosAutenticacion, datosLogin, true)
                      this.$store.commit('setAutenticacion', datosAutenticacion)
                      localStorage.setItem(this.dDatosAutenticacion, JSON.stringify(datosAutenticacion))
                      this.fObtenerDatosUsuario().then((result) => {
                        if (self.locale) {
                          self.locale = result.idiomaUsuario;
                        }
                        this.generateStatus()
                        this.$bus.$emit('evento-cargaPaginaApp')
                      });
                    }
                  })
                ]).then(result => {
                  // Establecemos el token para las siguientes llamadas con axios.
                  if (this.dEmpresaInformes === undefined || this.dEmpresaInformes === null) {
                    this.$bus.$emit('mostrarAvisos', '<b>' + this.$t('notDataLoginFound') + '</b><br/>' + this.$t('notDataLoginFoundDesc'))
                  } else if (this.dEmpresaInformes !== this.dEmpresaERP) {
                    this.dTextAvisoCambioEmpresa = this.$t('cambioEmpresaTexto1') + this.dEmpresaERP + this.$t('cambioEmpresaTexto2') + this.dEmpresaInformes + this.$t('cambioEmpresaTexto3')
                    this.dMostrarAvisoCambioEmpresa = true
                  } else {
                    // Entra en la aplicacion
                  }
                }).catch(error => {
                  console.error(error)
                  handleGenericLoginError()
                })
              }
            }).then(() => {
              // 
            }).catch(error => {
              console.error(error)
              handleGenericLoginError()
            })
          } else {
            handleGenericLoginError()
          }
        }).catch(error => {
          console.log(error)
          handleGenericLoginError()
        })
      } else {
        const tiraAux = (external && this.tira !== null) ? this.tira : localStorage.getItem('ddolSecurityKey')
        const datosLogin = {}

        if (datosLogin.errorCode) {
          this.textAviso = datosLogin.errorMsg
          this.mostrarAvisos = true
          this.dEsperandoLogin = false
        } else {
          this.token = tiraAux
          const datosAutenticacion = {
            tira: this.token
          }
          this.$store.commit('setAutenticacion', datosAutenticacion)
          localStorage.setItem(this.dDatosAutenticacion, JSON.stringify(datosAutenticacion))

          const informacionLogin = { tira: tiraAux }

          Promise.all([
            SrvUsers.datosUsuarioPortal(informacionLogin).then(response => {
              const datosUsuario = response.data
              if (datosUsuario.statusCode !== '200' && datosUsuario.result.length > 1) {
                this.textAviso = datosUsuario.errorMsg
                this.dEsperandoLogin = false
                this.mostrarAvisos = true
              } else {
                setDatosAutenticacionFromUsuario(datosUsuario, datosAutenticacion, datosLogin, false)
                this.$store.commit('setAutenticacion', datosAutenticacion)
                localStorage.setItem(this.dDatosAutenticacion, JSON.stringify(datosAutenticacion))
              }
            })
          ]).then(result => {
            this.generateStatus()
            this.$bus.$emit('evento-cargaPaginaApp')
          }).catch(error => {
            console.error(error)
            handleGenericLoginError()
          })
        }
      }
    },
    fCancelarCambioEmpresa() {
      this.dMostrarAvisoCambioEmpresa = false
      this.dEsperandoLogin = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/mixins/globals/mx-login.vue